import React from "react";
import injectSheet from "react-jss";
import Color from "../../styles/Color";
import classNames from "classnames";

const LinkButton = ({
  classes,
  color,
  onClick,
  children,
  disabled,
  className,
}) => (
  <button
    type="button"
    disabled={disabled === true ? true : false}
    className={classNames(classes.linkButton, className)}
    onClick={disabled === true ? () => {} : onClick}
    style={
      disabled
        ? { color: Color.gray() }
        : { color: color ? color : Color.blue() }
    }
  >
    {children}
  </button>
);
const styles = {
  linkButton: {
    border: 0,
    fontSize: "13px",
    padding: (props) => (props.padding ? props.padding : null),
    backgroundColor: "transparent",
    textDecoration: "underline",
  },
};

export default injectSheet(styles)(LinkButton);
